<template>
    <div>
        <div class="md:grid md:grid-cols-12 md:gap-6">
            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.min_damage')" for="price" />
                    <FormInput
                        required
                        id="min_damage"
                        v-model.number="form.min_damage"
                        name="min_damage"
                        type="number"
                        step="1"
                        class="mt-1"
                    />
                    <FormError :value="errors['options.min_damage']" class="mt-2" />
                </div>
            </div>

            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.max_damage')" for="price" />
                    <FormInput
                        required
                        id="max_damage"
                        v-model.number="form.max_damage"
                        name="max_damage"
                        type="number"
                        step="1"
                        class="mt-1"
                    />
                    <FormError :value="errors['options.max_damage']" class="mt-2" />
                </div>
            </div>
        </div>
        <div class="md:grid md:grid-cols-12 md:gap-6">
            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.boost_modifier')" for="boost_modifier" />
                    <FormInput
                        id="boost_modifier"
                        v-model.number="form.boost_modifier"
                        name="boost_modifier"
                        type="number"
                        step="0.01"
                        min="0"
                        max="50"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors['options.boost_modifier']" class="mt-2" />
                </div>
            </div>
            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.max_boost')" for="max_boost" />
                    <FormInput
                        id="max_boost"
                        v-model.number="form.max_boost"
                        name="max_boost"
                        type="number"
                        step="1"
                        min="0"
                        max="100"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors['options.max_boost']" class="mt-2" />
                </div>
            </div>
            <div class="sm:col-span-4">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.boost_cost')" for="boost_cost" />
                    <FormInput
                        id="boost_cost"
                        v-model.number="form.boost_cost"
                        name="boost_cost"
                        type="number"
                        step="1"
                        min="0"
                        max="100"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors['options.boost_cost']" class="mt-2" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'ItemWeaponOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
